export default __webpack_public_path__ + "static/florida-tech-87a6d574fe2e7c4a424e3faa01c8f3d7.svg";